export const PROFILE_ITEM_SIZE_DEFAULT = '48px';
export const PROFILE_ITEM_SIZE_LARGE = '56px';
